<ng-template #preHeader>
    <shared-disabled-text>SIGN IN /</shared-disabled-text> SIGN UP
</ng-template>
<ng-template #intro>
    {{description}}
</ng-template>


<shared-auth-wrapper>
    <shared-auth-header preHeaderMarginTop="lg" marginBottom="xs" [preHeader]="preHeader"
        [description]="description ? intro : null">
        {{title}}
    </shared-auth-header>
</shared-auth-wrapper>

<shared-form-for-link-account-rewards labelSubmit="Link account" [modal]="true">
</shared-form-for-link-account-rewards>